import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

// TODO: add more keys
interface IPaymentCard {
  is_default: boolean;
  payment_method_external_id: string;
  payment_method_uuid: string;
}

export interface IPaymentStore {
  paymentCards: IPaymentCard[];
  validationFailed: boolean;
  kushkiAddError: boolean;
  cardAddErrorMessage: string;
}

const initialState: IPaymentStore = {
  paymentCards: [],
  validationFailed: false,
  kushkiAddError: false,
  cardAddErrorMessage: '',
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentCards: (state, action) => {
      state.paymentCards = action.payload;
    },
    cleanupPaymentCards: state => {
      state.paymentCards = [];
    },
    validateOnSubmit: (state, action) => {
      state.validationFailed = action.payload;
    },
    errorOnCardAdd: (state, action: PayloadAction<boolean | string>) => {
      state.validationFailed = false;

      if (typeof action.payload === 'string') {
        const hasMessage = action.payload.length > 0;
        state.kushkiAddError = hasMessage;
        state.cardAddErrorMessage = action.payload;
        return;
      }

      state.kushkiAddError = action.payload;

      if (!action.payload) {
        state.cardAddErrorMessage = '';
      }
    },
  },
});

export const { setPaymentCards, cleanupPaymentCards, validateOnSubmit, errorOnCardAdd } = paymentSlice.actions;

export const selectPayment = (state: RootState) => state.payment;

export default paymentSlice.reducer;
